const numericValue = (value) => {
  const numeric = Number(value || 0);
  return Number.isFinite(numeric) ? numeric : 0;
};

// Losses and donations have separate checkpoints. Assessable income includes
// both; the balance before donations is only statutory income less losses.
export const calculateGroupReliefOutput = (detailed = {}, adjustment = {}) => {
  const adjustedProfitAfterCA =
    numericValue(detailed.adjustedProfit) +
    numericValue(detailed.priorYearCA) +
    numericValue(detailed.currentYearCA) +
    numericValue(adjustment.caTransfer);
  const statutoryIncome =
    adjustedProfitAfterCA + numericValue(detailed.otherSourcedIncome);
  const statutoryIncomeLessLosses =
    statutoryIncome +
    numericValue(detailed.priorYearLosses) +
    numericValue(detailed.currentYearLosses) +
    numericValue(adjustment.lossesTransfer);
  const assessableIncome =
    statutoryIncomeLessLosses +
    numericValue(detailed.priorYearDonations) +
    numericValue(detailed.currentYearDonations) +
    numericValue(adjustment.donationsTransfer);

  return {
    adjustedProfitAfterCA,
    statutoryIncome,
    statutoryIncomeLessLosses,
    assessableIncome,
    chargeableIncome: assessableIncome,
  };
};
